module.exports = __webpack_public_path__ + "static/media/icon-menu.96d129e1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/menutoggler/icon-menu.svg
// module id = 668
// module chunks = 0